






import Vue from "vue";
import { mountFOffline } from "@fkui/vue";
export default Vue.extend({
    name: "App",
    created() {
        mountFOffline(this.$t("SBRV.RW.generell.brodtext.ingenuppkoppling"));
    },
});
